import useThemeMode from "@hooks/utils/useThemeMode";
import { syncIntercomThemeMode } from "@themes/intercomTheme";
import { useLayoutEffect } from "react";

/** Catches mode changes from useColorScheme() that bypass useThemeMode wrappers. */
export function IntercomThemeSync() {
  const { mode } = useThemeMode();

  useLayoutEffect(() => {
    syncIntercomThemeMode(mode);
  }, [mode]);

  return null;
}
